<template>
	<v-container>
		<v-alert :type="alert.type" v-show="alert.show">
			{{ alert.message }}
		</v-alert>
		<form class="filterContainer">
			<v-card>
			<v-progress-circular
				indeterminate
				v-show="loadingData"
			/>

			<v-row>
				<v-col cols="12" md="7" sm="10" offset="1" :key="renderKey">
					<autocomplete-basic
						:items="formItems.mandator"
						:model.sync="formState.selectedMandators"
						label="Mandator"
						:errorCount="mandatorErrorCount"
						:search.sync="mandatorSearch"
						:errorMessage="mandatorErrorMessage"
					/>
				</v-col>
				<v-col cols="12" md="3" class="clearButtonFormatting">
					<v-btn
						@click="clearForm"
						:disabled="formState.selectedMandators.length == 0">
						{{txt.btn.clear}}
					</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="10" sm="10" offset="1" :key="renderKey">
					<autocomplete-basic
						:items="formItems.productGroups"
						:model.sync="formState.selectedProductGroups"
						label="Product Groups"
						:search.sync="productGroupSearch"
					/>
				</v-col>
			</v-row>
			<v-divider></v-divider>
			<v-row>
				<v-col cols="12" md="5" offset="1" class="rowFormatting">
					<v-switch
						v-model="transactionFeeSwitch"
						color="rgb(0,160,227)"
						:label="`Transaction fee for each mandator seperately`"
					></v-switch>
				</v-col>
			</v-row>
			<v-divider></v-divider>
			<v-row>
				<v-col cols="12" md="12">
				<v-card-title>{{cardTitle}}</v-card-title>
					<v-card-text>
						<!-- transaction fee input fields for all the sleected mandators -->
						<revenue-sum-report-transaction-fee-input
							:multipleFilter="transactionFeeSwitch"
							:mandatorList.sync="formState.selectedMandators"
						/>
					</v-card-text>
				</v-col>
			</v-row>

			<!-- Date ranges -->
			<v-row>
				<v-col cols="12" sm="10" md="5" offset="1">
					<date-picker
						label="Date From"
						:menu.sync="menuFrom"
						:date.sync="formState.dateFrom"
					/>
				</v-col>
				<v-col cols="12" sm="10" md="5" offset-sm="1" offset-md="0">
					<date-picker
						label="Date till"
						:menu.sync="menuTill"
						:date.sync="formState.dateTill"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6" >
					<v-btn
						class="white--text"
						color="rgb(0,160,227)"
						@click="submitFilters(false)"
						:disabled="btnDisabled"
					>{{txt.btn.submitFilters}}
					</v-btn>
				</v-col>
				<v-col cols="12" md="5">
					<v-btn
						class="black--text"
						color="green"
						outlined
						@click="submitFilters(true)"
						:disabled="btnDisabled"
					><v-icon>mdi-file-download</v-icon>{{txt.btn.excelExport}}
					</v-btn>
					<div class="cardSpacer"></div>
				</v-col>
			</v-row>
			</v-card>
		</form>
	</v-container>
</template>
<script>
import axios from 'axios'
import AutocompleteBasic from '../vueBasics/AutocompleteBasic.vue'
import DatePicker from '../arcCustom/DatePicker.vue'
import revenueSumReportTransactionFeeInput from './RevenueSumReportTransactionFeeInput.vue'

export default {
	name: 'RevenueReportSumFilter',
	components: {
		AutocompleteBasic,
		DatePicker,
		revenueSumReportTransactionFeeInput,
	},
	data() {
		return {
			renderKey: 0,
			loadingData: false,
			txt: {
				btn: {
					submitFilters: 'Submit',
					clear: 'Clear Selection',
					excelExport: 'Excel Export',
				},
			},
			formState: {
				selectedMandators: [],
				dateFrom: new Date().toISOString().substr(0, 10),
				dateTill: new Date().toISOString().substr(0, 10),
				selectedProductGroups: [],
			},
			formItems: {
				mandator: ['Mandators could not be loaded'],
				productGroups: ['Select a mandator'],
			},
			mandatorErrorCount: 0,
			mandatorErrorMessage: '',
			mandatorSearch: '',
			productGroupSearch: '',
			menuFrom: false,
			menuTill: false,
			transactionFeeSwitch: false,
			alert: {
				show: false,
				message: '',
				type: 'info',
			},
			rules: {
				required: (value) => !!value || 'Required.',
				dateFormat: (value) => {
					const pattern = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
					return pattern.test(value) || 'Date not in required format YYYY-MM-D'
				},
			},
		}
	},
	watch: {
		'formState.dateFrom': {
			handler() {
				this.setTillTime()
			},
		},
		'formState.selectedMandators': {
			handler() {
				this.handleSelectAll()
				this.getProductGroups('rsr')
				this.notEmptyMandator()
			},
		},
		'formItems.mandator': {
			handler() {
				this.notEmptyMandator()
			},
		},
	},
	computed: {
		btnDisabled() {
			if (this.formState.selectedMandators.length == 0) return true
			return false
		},
		cardTitle() {
			if (this.transactionFeeSwitch) return 'Enter a transaction fee for every selected mandator.'
			return 'Enter an averaged transaction fee - applies for every selected mandator'
		},
	},
	methods: {
		// eslint-disable-next-line consistent-return
		setTillTime() {
			if (this.formState.dateTill < this.formState.dateFrom) {
				this.formState.dateTill = this.formState.dateFrom
				return this.formState.dateTill
			}
		},
		notEmptyMandator() {
			if (this.formState.selectedMandators.length === 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Required field'
			} else {
				this.mandatorErrorCount = 0
				this.mandatorErrorMessage = ''
			}
		},
		async getMandators(appNameShort) {
			try {
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/mandator?appNameShort=${appNameShort}`)
				this.formItems.mandator = r.data
				this.formItems.mandator.unshift({ text: 'Select all', value: '1111' })
			} catch (e) {
				this.alert.show = true
				this.alert.type = 'error'
				this.alert.message = 'Product groups could not be loaded'
			}
		},
		async getProductGroups(appNameShort) {
			try {
				this.loadingData = true
				// eslint-disable-next-line no-undef
				const r = await axios.post(`${config.baseAPIurl}/revenue-sum-report/sku-groups`, {
					appNameShort,
					mandators: this.formState.selectedMandators,
				})
				const formattedToDisplay = r.data.map((x) => ({ value: x, text: x }))
				this.formItems.productGroups = formattedToDisplay
				this.loadingData = false
			} catch (e) {
				this.loadingData = false
				this.alert.show = true
				this.alert.type = 'error'
				this.alert.message = 'Product groups could not be loaded'
				// eslint-disable-next-line no-return-assign
				setTimeout(() => this.alert.show = false, 5000)
			}
		},
		submitFilters(excel) {
			if (this.formState.selectedMandators.length == 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Please select at least one mandator'
				return
			}
			this.mandatorErrorMessage = ''
			this.mandatorErrorCount = 0
			const selectedMandatorsSubmit = this.formState.selectedMandators.filter((x) => x.value !== '1111')
			const objToSubmit = {
				mandators: selectedMandatorsSubmit,
				dateFrom: this.formState.dateFrom,
				dateTill: this.formState.dateTill,
				productGroups: this.formState.selectedProductGroups.map((x) => x.value),
			}
			if (excel) this.$emit('excelExport', objToSubmit)
			else this.$emit('submit', objToSubmit)
		},
		async handleSelectAll() {
			const contains = this.formState.selectedMandators.filter((x) => x.value == '1111')
			if (contains && contains.length > 0
				&& this.formState.selectedMandators.length != this.formItems.mandator.length
			) {
				this.formState.selectedMandators = this.formItems.mandator
				this.renderKey += 1
			}
		},
		clearForm() {
			this.formState.selectedMandators = []
			this.renderKey += 1
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators('rr')
		})
	},
}
</script>
<style scoped>
form {
	padding: 60px 60px 0px 30px;
}

.filterContainer {
	padding: 0px !important;
}

.cardSpacer{
	padding-bottom: 25px;
}

.rowFormatting{
	margin-top: 0px;
	margin-bottom: 0px;
	padding-top: 0px;
	padding-bottom: 0px;
}

.clearButtonFormatting{
	padding-top: 35px;
}
</style>
